module.exports = __webpack_public_path__ + "img/em2.34ec99d9.png";